import {
    GET_GENERIC_GROUP,
    SAVE_GENERIC_GROUP,
    EDIT_GENERIC_GROUP,
    GENERIC_GROUP_REQUEST_BEGIN,
    GENERIC_GROUP_REQUEST_ABORT,
} from '../actions/types';

const initialState = {

    genericGroupRequestBegin: false,
    genericGroupRequestAbort: false,
    deletingGenericGroup: false,
    columnsFetchBegin: false,
    columnsFetchSuccess: false,
    columnsFetchFail: false,
    genericGroups: [],
};

export default function (state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GENERIC_GROUP_REQUEST_BEGIN:
            return {
                ...state,
                genericGroupRequestBegin: payload.genericGroupRequestBegin
            };
        case GENERIC_GROUP_REQUEST_ABORT:
            return {
                ...state,
                genericGroupRequestBegin: false,
            }
        case GET_GENERIC_GROUP:
            return {
                ...state,
                genericGroupRequestBegin: false,
                genericGroups: payload,
            };
        case SAVE_GENERIC_GROUP:
            return {
                ...state,
                genericGroupRequestBegin: false,
            };
        case EDIT_GENERIC_GROUP:
            return {
                ...state,
                genericGroupRequestBegin: false,
            };
        default:
            return state;
    }
}
